"use strict";
import React from "react";
function invoiceStatus(invoice) {
  if (invoice) {
    return /* @__PURE__ */ React.createElement("span", { className: "load-detail__invoice-status-text" }, "Status: ", invoice.status);
  }
}
function invoiceTitle(props) {
  var text = "Load " + props.load.load.load_id + " auto-confirmed";
  return /* @__PURE__ */ React.createElement("span", { className: "load-detail__invoice-header-text" }, text);
}
function AutoConfirmedLoadHeader(props) {
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: "load-detail__auto-confirmed-header",
      "data-component": "AutoConfirmedLoadHeader"
    },
    /* @__PURE__ */ React.createElement("h3", { className: "load-detail__invoice-header" }, invoiceTitle(props)),
    /* @__PURE__ */ React.createElement("h3", { className: "load-detail__invoice-status" }, invoiceStatus(props.carrierInvoice))
  );
}
export default AutoConfirmedLoadHeader;
